import { gql } from "@apollo/client";

export const CREATE_MEETING_TYPE = gql`
  mutation CreateMeetingType($input: MeetingTypeInput) {
    createMeetingType(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_MEETING_TYPE_PAGINATION = gql`
  query GetMeetingTypePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getMeetingTypePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        title
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_MEETING_TYPE = gql`
  mutation UpdateMeetingType($id: ID!, $input: MeetingTypeInput) {
    updateMeetingType(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_MEETING_TYPE = gql`
  mutation DeleteMeetingType($id: ID!) {
    deleteMeetingType(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
